import { createSelector } from 'redux-orm';

import orm from '../orm';

export const makeAlertResByIdSelector = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ AlertRes }, id) => {
      const alertModel = AlertRes.withId(id);

      if (!alertModel) {
        return alertModel;
      }

      return {
        ...alertModel.ref,
        alertSetting: alertModel.alertSetting?.ref,
        device: alertModel.device?.ref,
        item: alertModel.item?.ref,
        line: alertModel.line?.ref,
        site: alertModel.site?.ref,
      };
    },
  );

export const makeAlertOccurByIdSelector = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ AlertOccur }, id) => {
      const alertModel = AlertOccur.withId(id);

      if (!alertModel) {
        return alertModel;
      }

      return {
        ...alertModel.ref,
        alertSetting: alertModel.alertSetting?.ref,
        device: alertModel.device?.ref,
        item: alertModel.item?.ref,
        line: alertModel.line?.ref,
        site: alertModel.site?.ref,
      };
    },
  );

export const alertResByIdSelector = makeAlertResByIdSelector();
export const alertOccurByIdSelector = makeAlertOccurByIdSelector();
